<div class="panel panel-info">
    @if (employee$ | async; as employee) {
        <div class="panel-heading pb-2 pt-3">
            <h1>{{ employee.employeeName }}</h1>
        </div>
        <div class="panel-body pb-3">
            <div class="pb-1">
                <app-employee-edit
                    [updating]="updating"
                    [employee]="employee"
                    (changed)="changed.emit()"
                    (shiftSplitEmitter)="employeeAssignedTasksComponent.loadEmployeeTasks()"
                ></app-employee-edit>
            </div>
            <div class="container-flex">
                <h3
                    class="mb-2"
                    translate="EMPLOYEE_TASKS_FOR"
                    [translateParams]="{ value: employee.employeeName ? employee.employeeName : '' }"
                ></h3>
                <app-employee-assigned-tasks
                    [employee]="employee"
                    [disableDrag]="disableDrag"
                    (undraggableStateChanged)="undraggableStateChanged.emit($event)"
                ></app-employee-assigned-tasks>
            </div>
        </div>
    } @else {
        <span class="spinner spinner-lg absolute-centering"></span>
    }
</div>
